const initialState = {
  newStsAlert:false,
  alertID: '',
  epdID: '',
  altEditCntId: '',
  alertAptType: '',
  alertDate: '',
  missedAppointmentOn: '',
  altDsc: '',
  comment: '',
  altFlagYN: '',
  altInactiveYN: '',
  alertCreatedDate: '',
  alertEditedDate: '',
  altCbpOrgID: '',
  admittedToProgramOn: '',
  dichargedFromProgramOn: '',
  admissionMode: '',
  dischargeMode: '',
  altCbpCntID: '',
  dischargeReason: '',
  alertDischOthRsn: '',
  alertAptTypOth: '',
  altCreateCntId: '',
  alertAthType: '',
  urinalysisFor: '',
  alertUADate: '',
  emergencyMedicalCareAt: '',
  alertEmerCareDate: '',
  BehavioralOrTreatmentCaseConference: '',
  cbpProgram: {
    orgId: '',
    orgKey: '',
  },
  cbpContact: {
    cntID: '',
    cntKey: '',
    orgKey: '',
  },
  statusAlertCreatedBy: {
    id: '',
    value: '',
  },
  editedBy: {
    id: '',
    value: '',
  },
};

export default initialState;
